import { MobileRequest } from '@sai/protocol';

export default class ResetPasswordRequest extends MobileRequest {
    private controller: string;
    private service: string;
    private mail: string;
    private captcharesp: string;

    constructor(mail: string, captcharesp: string) {
        super('auth', 'reset', 'POST', null);
        this.mail = mail;
        this.captcharesp = captcharesp;
    }

    getUrl() {
        let url = this.controller;
        url += '/' + this.service;

        return url;
    }

    getSerializable(): { [prop: string]: any } {
        return {
            mail: this.mail,
            captcharesp: this.captcharesp,
        };
    }

    getSessionVars(): {}{
        return {};
    }

}